import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef} from 'react';
import {ReactiveTable} from "react-ive-tables";
import {UnprocessedBankTransactionResponse} from "../../lib/types/types";
import {formatNumber} from "../../lib/common";

interface Props {
    selectedTransaction: UnprocessedBankTransactionResponse;
}

const TransactionDetailsRow: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const getColumnTemplate = () => {
        return {
            amount: (rowData: UnprocessedBankTransactionResponse) => formatNumber(rowData.amount),
            remainingAmount: (rowData: UnprocessedBankTransactionResponse) => formatNumber(rowData.remainingAmount),
        }
    }

    return <>
            <h2 className={"font-bold"}>{f({id: "bankTransaction"})}</h2>
            <ReactiveTable
                columnOrder={['clientName', 'bankReference', 'valueDate', 'amount', 'remainingAmount', 'paymentDetails']}
                columnTemplate={getColumnTemplate()}
                showHeader={false}
                showPaginator={false}
                showFilters={false}
                data={[props.selectedTransaction]}
                specialLabels={{
                    clientName: "client",
                }}
            />
    </>
};

export default TransactionDetailsRow
